// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.
import { FixedWidthBuilder } from '../builder.mjs';
import { setDate, setDateDay, setDateMillisecond } from '../visitor/set.mjs';
/** @ignore */
export class DateBuilder extends FixedWidthBuilder {
}
DateBuilder.prototype._setValue = setDate;
/** @ignore */
export class DateDayBuilder extends DateBuilder {
}
DateDayBuilder.prototype._setValue = setDateDay;
/** @ignore */
export class DateMillisecondBuilder extends DateBuilder {
}
DateMillisecondBuilder.prototype._setValue = setDateMillisecond;

//# sourceMappingURL=date.mjs.map
